"use client";
import { Content } from "@/services/content/types";
import classNames from "classnames";
import Link from "next/link";
import SubscribeButton from "./subscribe-button";

type CategoryProps = {
  category: Content.Category;
  inverted?: boolean;
  showFollowToggle?: boolean;
  isLink?: boolean;
  centered?: boolean;
  asHeading?: boolean;
};

const Category = (props: CategoryProps) => {
  const parentCategory = props.category.fields.parentCategory;
  const color = props.category.fields.color || parentCategory?.fields.color;

  return (
    <div
      className={classNames("flex items-center", {
        "justify-center": props.centered,
      })}
    >
      {props.isLink ? (
        <Link href={`/amne/${props.category.fields.slug}`}>
          <CustomCategory
            name={props.category.fields.name}
            color={color}
            inverted={props.inverted}
            asHeading={props.asHeading}
          />
        </Link>
      ) : (
        <CustomCategory
          name={props.category.fields.name}
          color={color}
          inverted={props.inverted}
          asHeading={props.asHeading}
        />
      )}
      {props.showFollowToggle && (
        <SubscribeButton
          item={props.category}
          type="category"
          activeLabel="Följer"
          inactiveLabel="Följ"
          className="ml-5"
        />
      )}
    </div>
  );
};

export default Category;

type CustomCategoryProps = {
  name?: string;
  color?: Content.CategoryColors;
  inverted?: boolean;
  size?: "sm" | "md" | "xs";
  uppercase?: boolean;
  asHeading?: boolean;
};

export const CustomCategory = (props: CustomCategoryProps) => {
  const size = props.size || "xs";
  const uppercase = props.uppercase ?? true;
  const NameTag = props.asHeading ? "h2" : "div";

  return (
    <div className="flex items-center space-x-1">
      {props.name && (
        <NameTag
          className={classNames("font-bold", {
            "text-static-white": props.inverted,
            "text-lg": size === "md",
            "text-sm": size != "md",
            uppercase: uppercase,
          })}
        >
          {props.name}
        </NameTag>
      )}
    </div>
  );
};
